module.exports = __webpack_public_path__ + "img/eyes_male_asian_round.7470ad64.png";